// extracted by mini-css-extract-plugin
export default {"wrap":"KJ-z","fullWidth":"LJ-z","hideOnDesktop":"MJ-z","content":"NJ-z","hasOpenedNav":"OJ-z","crumbsList":"PJ-z","dropdownsWrap":"QJ-z"};